import axios from 'axios';
import { getAuth } from 'firebase/auth';

// Create axios instance
const axiosInstance = axios.create();

// Add request interceptor to inject Firebase Auth token
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (user) {
        // Get fresh ID token
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error getting auth token:', error);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - could trigger logout here
      console.error('Authentication error:', error.response.data);
    } else if (error.response?.status === 403) {
      // Forbidden - user not approved or lacks permission
      console.error('Authorization error:', error.response.data);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
